// extracted by mini-css-extract-plugin
export default {"button":"Tab_button__-0qkq","highlight":"Tab_highlight__7EvFp","active":"Tab_active__-FWY4","icon":"Tab_icon__T1fJv","text":"Tab_text__qhmYC"};